/**
 * @module addSmoothScrolling
 */

/**
 * Convenience function that returns a `<script>` block with logic that adds a click listener to all `<a>` tags, and if it is a link on the same page (e.g. An anchor), animates and scrolls smoothly to the `window.location.hash`.
 *
 * @param {number} scrollTime - The time value, in milliseconds, to use for scrolling duration.
 * @param {object} options - Optional data object of options. At present, this is only used to detect and get the value for options.nonce for the script tag.
 *
 * @returns {string} A script tag with the JavaScript functionality to add the click listener and handle accordingly.
 */
const addSmoothScrolling = (scrollTime, options = {}) => {
  const openingTag =
    options && options.nonce ? `<script nonce="${options.nonce}">` : '<script>';
  return `
    ${openingTag}
        $(document).ready(function(){
            $("a").on('click', function(event) {
                if ((this.hash !== "") && ((this.pathname === location.pathname) || ('/' + this.pathname === location.pathname)) && (this.search === location.search)) {
                    event.preventDefault();
                    var hash = this.hash;
                    $('html, body').animate({
                        scrollTop: $(hash).offset().top
                    }, ${scrollTime}, function(){
                        window.location.hash = hash;
                    });
                }
            });
        });
    </script>
    `;
};

module.exports = {
  addSmoothScrolling,
};
